export const LoginScreenStringLabels = {
  header: "AC Visitor Console Login",
  userName: "UserName",
  password: "Password",
  login: "Login",
  pwcLogin: "PWC Login",
};

export const Pass = "AdminConsoleSecretCode123";

export const ManageSubAdminStringLabels = {
  updateFormTitle: "Update Sub-Admin",
  addFormTitle: "Create New Sub-Admin",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  cancel: "Cancel",
  update: "Update",
  add: "Add",
  backToVisitScreenTitle: "Back to Visit Screen",
  manageSubAdmin: "Manage sub-admin",
  backToHome: "Back to Home Screen",
};

export const UserFeedbackStringLabels = {
  userFeedback: "FeedBack List",
  email: "Email",
  username: "userName",
  rating: "Rating",
  message: "Message",
  update: "Update",
  addFeedbackFormTitle: "Create New Feedback",
  add: "Add",
  cancel: "Cancel",
  userfeedback: "User FeedBack",
  backToVisitScreenTitle: "Back to Visit Screen",
  backToHome: "Back to Home Screen",
};

export const ManageAcStringLabels = {
  userFeedback: "FeedBack List",
  email: "Email",
  username: "userName",
  rating: "Rating",
  message: "Message",
  update: "Update",
  addFeedbackFormTitle: "Create New Feedback",
  add: "Add",
  cancel: "Cancel",
  userfeedback: "User FeedBack",
  backToVisitScreenTitle: "Back to Visit Screen",
  manageAc: "Manage ACs",
};

export const AppBarStringLabels = {
  title: "Client EXP",
  logout: "Logout",
  logOutSubTitle: "Are you sure you want to Logout",
};

export const ClientVisitScreenStringLabels = {
  overview: "Overview",
  active: "Active",
  completed: "Completed",
  upcoming: "Upcoming",
  createNew: " Create New",
  name: "Name",
  startDate: "Start Date",
  endDate: "End Date",
  region: "Region",
  cancel: "Cancel",
  update: "Update",
  create: "Create",
  delete: "Delete",
  deleteTitle: "Delete the Visit",
  clientName: "Client Name",
  companyName: "Company Name",
  companyLogo: "Company Logo",
  backToHomeScreen: "Back to Home Screen",
  visitCheckBoxLabel: "Please check if internal visit",
  visits: "Visits",
};

export const ClientProfileScreenStringLabels = {
  backToVisitsScreen: "Back to Visit Screen",
  manageInvitees: "Manage Invitees",
  manageModules: "Manage Modules",
  requests: "Requests",
  concierge: "AC Visit Partner",
  collaborators: "Collaborators",
  attendees: "Attendees",
  backToHome: "Back to Home Screen",
  resources: "Resources",
  analytics: "Analytics",
};

export const CommonStringLabels = {
  dismissNotification: "Dismiss notification",
};

export const PollingScreenStringLabels = {
  backToOfficeVisits: "Back to office visits",
  openVisitWorkspace: "Open visit workspace",
  standaloneTitle: "Polls",
  pageDescription:
    "Create questions, publish to attendees, and review responses for this visit.",
  savePoll: "Save poll",
  updatePoll: "Update poll",
  saving: "Saving…",
  loadingPoll: "Loading polls…",
  editAgain: "Edit poll",
  closePoll: "Close poll",
  closingPoll: "Closing…",
  pollClosedSuccess: "Poll closed.",
  viewOnlyLiveClosedNote:
    "Live and closed polls are read-only. Close a live poll from here, or edit draft polls only.",
  cancelEditing: "Cancel",
  pollsForVisit: "Polls for this visit",
  pollsSavedSuffix: "saved",
  newPoll: "New poll",
  singleLivePolicyNote:
    "Only one poll can be live at a time. Setting this poll to Live will close any other live poll for this visit.",
  statusDraftUntilSavedNote:
    "Save this poll as a draft first. You can publish it live after it has been saved.",
  deletePoll: "Delete poll",
  deletePollConfirmTitle: "Delete poll",
  deletePollConfirmSubtitle:
    "This will permanently remove this poll and its saved responses from this visit. This cannot be undone.",
  deletePollConfirmNamed:
    'This will permanently remove "{name}" and its saved responses from this visit. This cannot be undone.',
  deletePollSuccess: "Poll deleted.",
  deletePollLiveBlocked: "Close the poll before deleting (live polls cannot be removed).",
  deletePollLiveHint: "Live polls must be closed before they can be deleted.",
  deletingPoll: "Deleting…",
  statusLabel: "Poll status",
  statusDraft: "Draft",
  statusLive: "Live",
  statusClosed: "Closed",
  statusLiveOnPhones: "Live (on phones)",
  questionTypeSingleChoice: "MCQ (single answer)",
  questionTypeMultipleChoice: "MCQ (multiple answers)",
  questionTypeBoolean: "Boolean (Yes/No)",
  pollNamePlaceholder: "Enter a name for this poll",
  questionPromptPlaceholder: "Enter your question",
  defaultOptionPrefix: "Option",
  booleanYes: "Yes",
  booleanNo: "No",
  unsavedDraft: "Unsaved draft",
  pollMetadataTitle: "Poll details",
  pollNameLabel: "Poll name",
  showPollResultsLabel: "Show poll results to attendees",
  showPollResultsHint:
    "When enabled, attendees can see aggregated poll results on their phones after responding.",
  toggleOn: "On",
  toggleOff: "Off",
  questionsTitle: "Questions",
  questionIndexPrefix: "Q",
  questionTypeLabel: "Question type",
  promptLabel: "Prompt",
  requiredLabel: "Required",
  optionsLabel: "Options",
  remove: "Remove",
  addOption: "+ Add option",
  booleanOptionsFixed: "Boolean options are fixed: Yes / No",
  newDraftNote:
    "This is a new unsaved poll. Save it to add it to the list for this visit.",
  previewTitle: "Attendee preview",
  previewDescription: "How this poll will appear to visit attendees.",
  untitledPoll: "Untitled poll",
  untitledQuestion: "Untitled question",
  untitledOption: "Untitled option",
  untitled: "Untitled",
  totalResponsesLabel: "Total responses:",
  resultsEmptyValue: "—",
  defaultQuestionFallback: "Question",
  lastSavedPrefix: "Last updated:",
  pollUpdatedSuccess: "Poll updated successfully.",
  pollCreatedSuccess: "Poll saved successfully.",
  errorFetchFailed: "Unable to load polls. Please try again.",
  errorSaveFailed: "Unable to save poll. Please try again.",
  errorPollNotEditable:
    "Only draft polls can be edited. Close a live poll or create a new draft.",
  errorDeleteFailed: "Unable to delete poll. Please try again.",
  errorResultsFailed: "Unable to load poll results.",
  errorPollNotFound: "Poll not found.",
  errorResultsDraft: "Results are not available for draft polls.",
  errorDeleteLive: "Close the poll before deleting.",
  resultsTitle: "Poll results",
  resultsDraftHint:
    "Results appear here once the poll is Live or Closed. Draft polls do not collect responses.",
  resultsLiveHint:
    "This poll is live — totals update in real time as attendees respond on their phones.",
  resultsLiveWaiting:
    "No responses yet, or still loading. Keep this screen open — totals update live when attendees submit on their phones.",
  resultsLiveConnected: "Live results connected",
  resultsLiveConnecting: "Connecting to live results…",
  resultsLiveDisconnected: "Live updates unavailable. Showing last loaded results.",
  resultsLiveAuthError:
    "Could not connect for live updates. Check that the socket server accepts your login token.",
  resultsClosedHint: "Final results for this closed poll.",
  resultsLoading: "Loading results…",
  resultsUnavailable: "Unable to load results for this poll.",
  resultsNoResponses: "No responses recorded yet.",
  noPollsYet: "No polls saved yet for this visit.",
  saveDisabledValidation: "Fill in every question prompt and at least two options per MCQ.",
  saveDisabledLoading: "Wait until loading finishes.",
};

export function getPollingStatusLabel(status) {
  switch (status) {
    case "live":
      return PollingScreenStringLabels.statusLive;
    case "closed":
      return PollingScreenStringLabels.statusClosed;
    case "draft":
    default:
      return PollingScreenStringLabels.statusDraft;
  }
}

export function getPollingStatusOptions() {
  return [
    { value: "draft", label: PollingScreenStringLabels.statusDraft },
    { value: "live", label: PollingScreenStringLabels.statusLiveOnPhones },
    { value: "closed", label: PollingScreenStringLabels.statusClosed },
  ];
}

export function getPollingQuestionTypes() {
  return [
    {
      value: "single_choice",
      label: PollingScreenStringLabels.questionTypeSingleChoice,
    },
    {
      value: "multiple_choice",
      label: PollingScreenStringLabels.questionTypeMultipleChoice,
    },
    {
      value: "boolean",
      label: PollingScreenStringLabels.questionTypeBoolean,
    },
  ];
}

export function getDefaultBooleanOptions() {
  return [
    PollingScreenStringLabels.booleanYes,
    PollingScreenStringLabels.booleanNo,
  ];
}

export function getDefaultMcqOptions() {
  return [
    `${PollingScreenStringLabels.defaultOptionPrefix} 1`,
    `${PollingScreenStringLabels.defaultOptionPrefix} 2`,
  ];
}

export function formatDefaultOptionLabel(index) {
  return `${PollingScreenStringLabels.defaultOptionPrefix} ${index}`;
}

export function resolvePollingMessage(message) {
  if (!message) {
    return "";
  }
  return PollingScreenStringLabels[message] || message;
}

export function formatDeletePollConfirmMessage(pollName) {
  if (!pollName) {
    return PollingScreenStringLabels.deletePollConfirmSubtitle;
  }
  return PollingScreenStringLabels.deletePollConfirmNamed.replace("{name}", pollName);
}

export const UserScreenStringLabels = {
  userFormUpdate: "Update User",
  userFormAdd: "New User",
  name: "Name",
  email: "Email Address",
  phone: "Phone Number",
  cancel: "Cancel",
  update: "Update",
  add: "Add",
  userList: "Invitees List",
  userName: "Name",
  countryCode: "Country Code",
  userExistMessage: "User exists in",
  checkingEmailMessage :"Checking email existence"
};

export const GeneralNotificationLabels = {
  generalNotificationFormTitle: "Add new General Notification",
  title: "Title",
  subTitle: "Sub-title",
  add: "Add",
  cancel: "Cancel",
  generalNotification: "General Notification",
  uploadFiles: "Upload Files",
};

export const ManageModulesStringLabels = {
  gateWayToPossibilities: "Gateway to Possibilities",
  titansOfIndustry: "Collaborators",
  getToKnowAC: "Get To Know AC",
  rendezvous: "Events",
  recharge: "Recharge",
  refuel: "Refuel",
  roam: "Roam",
  save: "Save",
  addResource: "Add Resource",
  add: "Add",
  importResources: "Import Resources",
  resources: "Resources",
  analytics:"Analytics",
  attendes: "Attendes",
};

export const GetToKnowAC = {
  getToKnowAC: "Get To Know AC",
  save: "Save",
  add: "Add",
  cancel: "Cancel",
  update: "Update",
  description: "Description",
};

export const UploadFilesString = {
  kb: "KB",
  dragDrop: "Drag and Drop or ",
  chooseAFile: "choose a file",
};

export const ImageGalleryString = {
  photos: "Photos",
  noPhoto: "No More Images!",
  noMedia: "Video/Audio is not added",
};

export const WelcomeScreenStringLabels = {
  updateWelcomeMessage: "Update Welcome Message",
  //updateConciergeMailid: 'Update Concierge Mail id',
  updateWelcomeVideo: "Update Welcome Video",
  replace: "Replace",
};

export const TitansOfIndustryStringLabels = {
  titansOfIndustry: "Collaborators",
  attendees: "Attendees",
  aboutMe: "About Me",
  aboutTitleContent: "About title content...",
  viewMyVideo: "View My Video",
  name: "Name",
  region:"Region",
  jobTitle: "Job Title",
  jobTitleOther: "Job Title (Others)",
  company: "Company",
  role : "Role",
  practice: "Practice",
  videoLink: "Video link",
  cancel: "Cancel",
  update: " Update",
  email: "Email",
  add: "Add",
  feedbacklist: "Feedback List",
  select: "Select",
  unSelect: "Remove",
};

export const OfficeListLabels = {
  pwcAcOfficeList: "PwC AC Office List",
  officeList: "Office List",
  managemodules: "Manage Module",
  officemanagecard: "Office Manage Card",
  title: "Title",
  description: "Description",
  officeLocation: "Office Location",
  officeAddress: "Office Address",
  city: "City",
  country: "Country",
  manageac: "Manage AC",
  available: "Available Now",
  unavailable: "Unavailable",
  toggleon: "Available",
  toggleoff: "Unavailable",
  updateFormTitle: "Update AC Card",
  backToOfficeListScreenTitle: "Back to Home Screen",
  name: "Name",
  latitude: "Latitude",
  longitude: "Longitude",
};

export const ResourcesLabels = {
  title: "Title",
  description: "Description",
  link: "Link",
  videoLink: "Video Link",
  visitRelatedResources: "Visit Related Resources",
  generalResources: "General Resources",
  fileName: "File Name",
  fileType: "File Type",
  uploadedFile: "Uploaded File",
  thumbnailPhoto: "Thumbnail Photo",
  allowDownload: "Allow Download",
  videoLinkAvailable: "Please check if video link available",
  update: "Update",
  generalDes: "Upload common documents applicable to different visits here. Navigate to required visit to import the files.",
  addAnother: "Add Another",
  fileThumbnailPhoto: "File Thumbnail Photo",
  materials: "Materials",
  cancel: "Cancel",
  upload: "Upload",
  disclaimerText: "Confidential. This document was generated by an automated software offering licensed by the user or the user’s employer (“Licensee”). The content of this document relies on the accuracy and completeness of information and materials provided by Licensee; such information and materials are not verified by the offering licensor. This document is not a substitute for consultation with appropriate professional services providers. The offering licensor disclaims all liability relating to Licensee’s use or deployment of this document, including decisions, actions, or omissions taken or not taken by Licensee in reliance on this document. This document is for Licensee’s use only, and not for the use, benefit, or reliance of any other party. The offering licensor assumes no duty or liability to any other part."
};

export const ConciergeStringLabels = {
  concierge: "AC Visit Partner",
  addConcierge: "Add AC Visit Partner",
  add: "Add",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  aboutMe: "AC Visit Partner Message",
  photo: "Photo",
  update: "Update",
  cancel: "Cancel",
  ccEmails: "CC Emails",
};

export const RendezvousStringLabels = {
  rendezvous: "Events",
  eventName: "Event Name",
  eventType: "Event Type",
  date: "Date",
  time: "Time",
  location: "Location",
  speakers: "Collaborators",
  getReady: "Get Ready",
  modifiedOn: "Modified On",
  users: "Users",
  startTime: "Start Time",
  description: "Description",
  endTime: "End Time",
  materials: "Materials",
  cancel: "Cancel",
  update: "Update",
  add: "Add",
};

export const RecreationStringLabels = {
  roam: "Roam",
  name: "Name",
  filter: "Filter",
  area: "Area",
  timing: "Timing",
  address: "Address",
  description: "Description",
  photo: "Photo",
  latitude: "Latitude",
  longitude: "Longitude",
  thumbnail: "Recreation Thumbnail Photo",
  photos: "Recreation Photos",
  update: "Update",
  add: "Add",
  cancel: "Cancel",
  formTitleUpdate: "Update Roam",
  formTitleAdd: "New Roam",
  openingTime: "Opening Time",
  closingTime: "Closing Time",
  closedDays: "Closed Days",
};

export const RefuelStringLabels = {
  refuel: "Refuel",
  name: "Name",
  filter: "Filter",
  type: "Type",
  price: "Price ",
  address: "Address",
  description: "Description",
  photo: "Photo",
  thumbnail: "Refuel Thumbnail Photo",
  latitude: "Latitude",
  longitude: "Longitude",
  photos: "Refuel Photos",
  update: "Update",
  add: "Add",
  cancel: "Cancel",
  formTitleUpdate: "Update Refuel",
  formTitleAdd: "Add Refuel",
  viewAllPhotos: "View all Photos",
};

export const RechargeStringLabels = {
  recharge: "Recharge",
  hotelName: "Hotel Name",
  description: "Description",
  location: "Location",
  distanceAndDuration: "Distance & Duration",
  time: "Driving time to AC",
  address: "Address",
  photo: "Photo",
  distance: "Distance",
  checkInTime: "Check-In-Time",
  checkOutTime: "Check-Out-Time",
  viewAllPhotos: "View all Photos",
  latitude: "Latitude",
  longitude: "Longitude",
  drivingTime: "Driving Time",
  thumbnail: "Hotel Thumbnail Photo",
  photos: "Recharge Photos",
  cancel: "Cancel",
  update: "Update",
  add: "Add",
  checkIn: "Check-in:",
  checkOut: "Check-out:",
};

export const ErrorMessagesStringLAbels = {
  message204: "no record found",
  message400: "Some fields are missing",
  message401: "logout and try logging in again",
  message404: "Something went wrong try again after some time",
  message500: "Something went wrong try again after some time",
  defaultmessage: "refresh and try again",
};

export const RequestScreenStringLabels = {
  cab: "Cab",
  hotel: "Hotel",
  new: "New",
  booked: "Booked",
  hotelScheduleFormTitle: "Hotel Booked Info",
  hotelName: "Hotel Name",
  checkInDate: "Check-In-Date",
  checkOutDate: "Check-Out-Date",
  cancel: "Cancel",
  book: "Book",
  userName: "User Name",
  pickUpTime: "Pick-Up Time",
  pickUpLocation: "Pick-Up Location",
  dropTime: "Drop Time",
  dropLocation: "Drop Location",
  cabDriverName: "Cab Driver Name",
  rechargeRequest: "Recharge Request",
  fromDate: "From Date",
  toDate: "To Date",
  preferences: "Preferences",
  additionalRequest: "Additional Request",
  rideInfo: "Ride Info",
  location: "Pick-up Point",
  destination: "Destination",
  add: "Add",
  date: "Date",
  time: "Time",
  contact: "Contact",
  car: "Car Info",
  shareCabInfo: "Create New Cab Request",
  selectUser: "Select User",
  contactName: "Contact Name",
  contactNo: "Contact Number",
  carName: "Car Name",
  carReg: "Car Registration Number",
  carType: "Car Type",
  update: "Update",
  overlapErrorMessage:
    "You have an overlapping booking against this date. Please adjust the booking date or pick-up/drop time to manage the booking.",
  updateCabInfo: "Update Cab Request",
};

export const SupportStringLabels = {
  firstname: "Riddhi",
  lastname: "Gandhi",
  email: "riddhi.gandhi@pwc.com",
  uploadPhoto: "Upload Photo",
  header: "Support for AC Visitor Console",
};
export const FormValidationStringLabels = {
  name: "Name is required",
  title: "Title is required",
  titleRegexCondition: "Title can only contain alpha-numeric characters",
  subTitle: "Sub-title is required",
  contactName: "Cab driver name is required",
  nameRegexCondition: "Name can only contain uppercase or lowercase characters",
  alphanumericName: "Name can only contain alpha-numeric characters",
  hotelId: "Select the hotel",
  contactNumber: "Contact number is required",
  phoneNumber: "Phone number is required",
  carName: "Car name is required",
  carRegNumber: "Car registration number is required",
  carType: "Car type is required",
  description: "Description is required",
  email: "Email is required",
  emailRegexCondition: "Please enter valid email address",
  phoneRegexCondition :"Phone number must be numeric and not more than 10 digits",
  location: "Location is required",
  address: "Address is required",
  latitude: "Latitude is required",
  linkRequired: "Link is required",
  videoLinkRequired: "Video link is required",
  urlNotValid: "Link invalid",
  longitude: "Longitude is required",
  invalidLatitude: "Please enter valid latitude",
  invalidLongitude: "Please enter valid Longitude",
  maxLength200: "Max length of only 200 characters are allowed",
  filter: "Filter is required",
  maxLength50: "Max length of only 50 characters are allowed",
  charNumRegex:
    "can only contain uppercase & lowercase letters, digits from 0-9",
  onlyDigits: "can only contain digits 0-9",
  minMaxLengthPhoneNo: "can be max of 10 digits and min of 9 digits",
  minMaxCarRegNo: "can have max of 11 and min of 9 characters",
  maxLength100: "Max length of only 100 characters are allowed",
  specialCharsRegexCondition:
    "can only contain uppercase, lowercase letters and digits from 0-9",
  maxLength500: "Max length of only 500 characters are allowed",
  maxLength20: "Max length of only 20 characters are allowed",
  startDate: "Start date is required",
  endDate: "End date is required",
  region: "Region is required",
  maxLength32: "Max length of 32 characters are only allowed",
  eventDate: "Event date is required",
  drivingTime: "Driving Time is a required",
  eventStartTime: "Event start time is required",
  openingTime: "Roam opening time is required",
  closingTime: "Roam closing time is required",
  closedDays: "Roam closed Days is required",
  eventEndTime: "Event end time is required",
  checkInTime: "Checkin time is required",
  checkOutTime: "Checkout time is required",
  checkInDate: "Checkin date is required",
  checkOutDate: "Checkout date is required",
  invalidEndTime: "Please enter valid event end time",
  invalidEndDate: "Please enter valid event end date",
  invalidVisitEndDate: "Please enter valid visit end date",
  conciergeMail: "email is a required",
  designation: "Designation is required",
  designationOther: "Designation(Others) is required",
  // companyName: 'Company name is required',
  invalidCloseTime: "Please enter valid closing time",
  practice: "Practice is required",
  aboutMe: "About me is required",
  descriptionRequired: "Description is required",
  eventType: "Event type is required",
  speaker: "Collaborator required. Please select from the dropdown below",
  type: "Type is required",
  price: "Price is required",
  invalidPrice: "Please enter valid price value",
  area: "Area is required",
  timing: "Timing is required",
  checkInDateGreater: "Check In Date cannot be before Check Out Date",
  welcomeMessage: "Welcome Message is required",
  maxLength250: "Max length of only 250 characters are allowed",
  userId: "Select the user its required field",
  fromLocation: "Source is required",
  toLocation: "Destination is required",
  date: "Booking date is required",
  pickupTime: "Pick-up time is required",
  dropTime: "Drop time is required",
  user: "Select an user",
  pickupLocation:"Pick-up location is required",
  dropLocation:"Drop location is required",
  mediaRequired: "Video/audio is required for collaborator",
  fileTypeRequired: "File type is required",
  titleRequired: "Title is required",
  fileBlobStorageRequired : "File not uploaded to the server",
  userSelectionRequired: "Please select users for this event"
  //conciergeMail: 'Concierge Mail is required'
};
export const AnalyticsStringLabel={
  visitSummaryHeading:"Visit Summary (Last 12 Months)",
  noValidDataMessage:"No valid data available"

}